import React from 'react';
import { Box, Typography, Iconography } from '@lucid/lego';
import styles from './AccordionHeader.module.scss';

export type AccordionHeaderProps = {
  theme: 'light' | 'dark';
  iconName: string;
  iconCategory: 'global' | 'map' | 'arrows';
  title: string;
  subtitle: string;
  actionButton?: React.ReactNode;
};

/**
 * Accordion header for alert banners — displays an icon, title, subtitle, and an optional action button.
 * @component
 * @param props.theme - Theme for the component
 * @param props.iconName - Icon name from the Iconography component
 * @param props.iconCategory - Icon category
 * @param props.title - Primary title text
 * @param props.subtitle - Secondary description text
 * @param props.actionButton - Optional action button rendered on the right
 * @returns {JSX.Element}
 */
export const AccordionHeader: React.FC<AccordionHeaderProps> = ({
  theme,
  iconName,
  iconCategory,
  title,
  subtitle,
  actionButton,
}) => (
  <Box className={styles.headerContent}>
    <Box className={styles.content}>
      <Iconography category={iconCategory} name={iconName} color="black" theme={theme} />
      <Box className={styles.text}>
        <Typography variant="label" size="medium" theme={theme} color="black">
          {title}
        </Typography>
        <Typography variant="body" size="small" theme={theme} color="black">
          {subtitle}
        </Typography>
      </Box>
    </Box>
    {actionButton}
  </Box>
);

AccordionHeader.displayName = 'AlertAccordionHeader';
